import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderSourceResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER SOURCE]';
export const orderSourceActions =
  createBaseResourceActions<OrderSourceResourceTypeMappings>(domainSlug);
